import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {DialogBody, DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'

const SkeletonField = () => (
    <Flexbox direction="column" gap={1.5} fullWidth>
        <Skeleton height="16px" width="80px" />
        <Skeleton height="40px" width="100%" />
    </Flexbox>
)

const SkeletonRadioGroup = () => (
    <Flexbox direction="column" gap={1.5} fullWidth>
        <Skeleton height="16px" width="80px" />
        <Grid columns={2} columnGap={4} fullWidth>
            <Skeleton height="48px" width="100%" />
            <Skeleton height="48px" width="100%" />
        </Grid>
    </Flexbox>
)

const SkeletonDateTimeSection = () => (
    <Grid columns={2} columnGap={4} rowGap={4} fullWidth>
        <SkeletonField />
        <SkeletonField />
        <SkeletonField />
        <SkeletonField />
        <GridItem spanColumn={2}>
            <SkeletonField />
        </GridItem>
    </Grid>
)

export const EditAccessDialogSkeleton = () => {
    return (
        <>
            <DialogBody>
                <Grid columns={2} columnGap={4} rowGap={6} fullWidth>
                    <SkeletonField />
                    <SkeletonField />
                    <SkeletonField />
                    <SkeletonField />

                    <GridItem spanColumn={2}>
                        <SkeletonRadioGroup />
                    </GridItem>

                    <GridItem spanColumn={2}>
                        <SkeletonDateTimeSection />
                    </GridItem>
                </Grid>
            </DialogBody>
            <DialogFooter>
                <Skeleton height="32px" width="100px" />
                <Skeleton height="32px" width="100px" />
            </DialogFooter>
        </>
    )
}
